<h1 mat-dialog-title>اختر لغتك</h1>
<mat-dialog-content class="mat-typography">
    <div class="container" style="width: 600px;">
        <!-- <div class="row mb-4">
            <div class="col-md-4">
                <a href="">English</a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
        </div> -->
        <div class="row mb-4">
            <div class="col-md-4">
                <p (click)="selectedLanguage('english')">English</p>
            </div>
            <div class="col-md-4">
                <p (click)="selectedLanguage('Arabic')">Arabic</p>
                <!-- <a href=""> عربی
                    <br>Arabic
                </a> -->
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-4">
                <a href="">English</a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-4">
                <a href="">English</a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-4">
                <a href="">English</a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-4">
                <a href="">English</a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-4">
                <a href="">English</a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-4">
                <a href="">English</a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
          
        </div>
        <div class="row mb-4">
            <div class="col-md-4">
                <a href="">English</a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
            <div class="col-md-4">
                <a href=""> عربی
                    <br>Arabic
                </a>
            </div>
         
        </div>
    </div>
</mat-dialog-content>
<!-- <mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button>
</mat-dialog-actions> -->